import api from "./apiService";
import { TOKEN_REFRESH } from "./apiRoutes";

const ACCESS_TOKEN_KEY = "jwt_access_token";
const REFRESH_TOKEN_KEY = "jwt_refresh_token";

export const getAccessToken = () => localStorage.getItem(ACCESS_TOKEN_KEY);
export const setAccessToken = (token) =>
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
export async function refreshAccessToken() {
  const refresh = getRefreshToken();
  if (!refresh) {
    throw new Error("No refresh token available");
  }
  const response = await api.post(TOKEN_REFRESH, { refresh });
  const { access } = response.data;
  setAccessToken(access);
  return access;
}
export const clearAccessToken = () => localStorage.removeItem(ACCESS_TOKEN_KEY);

export const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);
export const setRefreshToken = (token) =>
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
export const clearRefreshToken = () =>
  localStorage.removeItem(REFRESH_TOKEN_KEY);

export const clearTokens = () => {
  clearAccessToken();
  clearRefreshToken();
};
